import styled from "styled-components";

const ButtonNoBorder = styled.button`
  border: none;
`;

export default ButtonNoBorder;
